import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { touristSourceAddComparator, touristSourceRemoveComparator } from './../../../actions'
import { touristSourceSetRegion, touristSourceSetDataType, touristSourceSetSource, touristSourceMapVisualizerSetShownState } from './../../../actions'

import ComparatorFilters from './../shared/ComparatorFilters'
import { getTouristSourceDataTypeMenuItems } from './../../../libs/DataTypes'

import './Comparator.css'

class Comparator extends Component {

    /* Lifecycle */
     
    render() {

        return (
            <div className="pages-accommodations-comparator">
                {
                    this.props.comparators.map((comparatorState, index) => {
                        /*
                        return (
                            <ComparatorFilters 
                                key={index}
                                onAddComparator={index < 1 && this.props.comparators.length < 2 ? this.props.actions.addComparator : null}
                                onRemoveComparator={index > 0 && this.props.comparators.length > 1 ? this.props.actions.removeComparator : null}
                                regionValue={comparatorState.region}
                                onRegionChange={(region) => this.props.actions.setRegion(index, region)}
                                dataTypeValue={comparatorState.dataType}
                                onDataTypeChange={(dataType) => this.props.actions.setDataType(index, dataType)}
                                dataTypes={getTouristSourceDataTypeMenuItems()}
                                sourceValue={comparatorState.source}
                                onSourceChange={(source) => this.props.actions.setSource(index, source)}/>
                        )
                        */

                        return (
                            <ComparatorFilters 
                                key={index}
                                onAddComparator={index < 1 && this.props.comparators.length < 2 ? this.props.actions.addComparator : null}
                                onRemoveComparator={index > 0 && this.props.comparators.length > 1 ? this.props.actions.removeComparator : null}
                                regionValue={comparatorState.region}
                                onRegionChange={(region) => this.props.actions.setRegion(index, region)}
                                dataTypeValue={comparatorState.dataType}
                                onDataTypeChange={(dataType) => {
                                        this.props.actions.setDataType(index, dataType)
                                        this.props.actions.mapVisualizerSetShownState(index, null, dataType, null)
                                    }
                                }
                                dataTypes={getTouristSourceDataTypeMenuItems(this.context.t)}
                                sourceValue={comparatorState.source}
                                onSourceChange={(source) => {
                                    this.props.actions.setSource(index, source),
                                    this.props.actions.mapVisualizerSetShownState(index, null, null, source)
                                }}/>
                        )
                    })
                }
            </div>
        )
    }
}

Comparator.contextTypes = {
    t: PropTypes.func
}

const mapStateToProps = state => ({
    comparators: state.touristSourceComparator.comparators
})

function mapDispatchToProps(dispatch) {
    return { 
        actions: {
            addComparator: bindActionCreators(touristSourceAddComparator, dispatch),
            removeComparator: bindActionCreators(touristSourceRemoveComparator, dispatch),
            setRegion: bindActionCreators(touristSourceSetRegion, dispatch),
            setDataType: bindActionCreators(touristSourceSetDataType, dispatch),
            setSource: bindActionCreators(touristSourceSetSource, dispatch),
            mapVisualizerSetShownState: bindActionCreators(touristSourceMapVisualizerSetShownState, dispatch)
        }
    }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(Comparator)


// WEBPACK FOOTER //
// ./src/components/pages/tourist_source/Comparator.js